import ListItem from "@mui/material/ListItem";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";

const useStyles = makeStyles(() => ({
  selected: {
    "&.Mui-selected": {
      backgroundColor: "#1976d214",
    },
    " &.Mui-selected:hover": {
      backgroundColor: "#1976d214",
    },
  },
  child: {
    paddingLeft: "2.3rem",
  },
}));

const HamburgerMenuListItem = (props) => {
  const classes = useStyles();

  const renderMenuListItem = () => {
    return (
      <ListItem
        key={props.menuItemConfig.key}
        button
        component={props.isParent ? "" : Link}
        to={props.isParent ? "" : props.menuItemConfig.path}
        onClick={props.onClick}
        selected={props.selected}
        className={`${classes.selected} ${props.isChild && classes.child}`}
      >
        {props.children}
      </ListItem>
    );
  };

  return props.menuItemConfig.isActiveOnMobile ? renderMenuListItem() : props.isDesktopView ? renderMenuListItem() : "";
};

export default HamburgerMenuListItem;
